// extracted by mini-css-extract-plugin
module.exports = {"cardSupplyDays":"styles_cardSupplyDays__ZHPx6","boldDateText":"styles_boldDateText__ehh4B","expressSupplyDays":"styles_expressSupplyDays__2Ph_X"};